module.exports = __webpack_public_path__ + "static/media/blog-40-2.a61def60.webp";